import { DisplayTime } from 'common/display-state/display-time.js';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { ConditionType, iconForCondition } from 'types/condition.js';
import { IWind } from 'types/location';
import { isNotNullOrUndefined } from 'utilities/isType.js';

export type ParkPanelProps = {
  condition?: ConditionType;
  forecast?: string;
  wind?: Partial<IWind>;
  rainfall?: string | number;
  precipitation?: number;
  windChill?: number;
  issuedAt?: string;
};

export const ParkPanel = ({
  value: { condition, forecast, wind, rainfall, precipitation, windChill, issuedAt },
}: {
  value: ParkPanelProps;
}) => {
  return (
    <>
      {wind && (
        <IconWithText icon="wind" classes="IconWithText--vCenter u-mT-sm">
          <h4 className="u-mT-0 u-mB-0">Winds</h4>
          <small className="u-block">
            {wind.direction} {wind.averageSpeed}km/h
          </small>
        </IconWithText>
      )}

      {isNotNullOrUndefined(precipitation) && (
        <IconWithText icon="precipitation" classes="IconWithText--vCenter u-mT-sm">
          <h4 className="u-mT-0 u-mB-0">Precipitation amount</h4>
          <small className="u-block">{precipitation}%</small>
        </IconWithText>
      )}

      {isNotNullOrUndefined(rainfall) && (
        <IconWithText icon="rainfall" classes="IconWithText--vCenter u-mT-sm">
          <h4 className="u-mT-0 u-mB-0">6 hr rainfall amount</h4>
          <small className="u-block">{rainfall}mm</small>
        </IconWithText>
      )}

      {isNotNullOrUndefined(windChill) && (
        <IconWithText icon="wind-chill" classes="IconWithText--vCenter u-mT-sm">
          <h4 className="u-mT-0 u-mB-0">Wind Chill Temp</h4>
          <small className="u-block">{windChill}°</small>
        </IconWithText>
      )}

      {condition ? (
        <IconWithText icon={iconForCondition(condition)} classes="u-mT-sm">
          {forecast}
        </IconWithText>
      ) : (
        forecast && <p>{forecast}</p>
      )}

      {issuedAt && (
        <small className="fineprint u-block u-textGrey u-mT-xs">
          Issued: <DisplayTime date={issuedAt.toString()} />
        </small>
      )}
    </>
  );
};
